

//NOTE(@duncanmid): match height

jQuery(function () {

	jQuery('.camera-block-inner').matchHeight();
	jQuery('.offerta-block-wrapper').matchHeight();
});


jQuery(function () {

	var formAbs = jQuery('.menu-wrapper');

	if (formAbs.length > 0) {

		var boxPosition = formAbs.offset().top;

		jQuery(window).scroll(function () {

			var scrollPosition = jQuery(document).scrollTop();
			if (scrollPosition > boxPosition) {

				formAbs.addClass('scroll');

			} else {

				formAbs.removeClass('scroll');
			}
		});
	}
});


(function ($) {
	
	
	/**
	 * Funzione per nascondere e visualizzare la testata allo scroll della pagina
	 */

	function scrollHeader() {
		$('#js-header').scrollHide({
			scrollDelta: 10,
			scrollOffset: 110,
			scrollClass: 'scrh-header',
			scrollClassHide: 'scrh-hide',
			onScroll: function( context, msg, currentTop ) {
				if ( currentTop !== 0 ){
					$('.menu-offcanvas').removeClass( 'offcanvas-open' );
				}
				
				if ( currentTop === 0 ) {
					$('.menu-offcanvas').removeClass( 'offcanvas-open' );
				}
				
			}
		});
	}
	

	function allClick() {
		var clickbox = $('.allclick');
		clickbox.each(function () {
			var $this = $(this);
			$this.css('cursor', 'pointer');
			$this.find('a').click(function (event) {
				event.preventDefault();
			});

			if ($this.find('a').attr('target') == '_blank') {
				$this.click(function () {
					window.open($('a', this).attr('href'));
				});
			} else {
				$this.click(function () {
					window.location.href = $('a', this).attr('href');
				});
			}
		});
	}


	function cameraClick() {
		var clickbox = $('.cameraclick');
		clickbox.each(function () {
			var $this = $(this);

			var camera = $this.data('camera');

			$this.css('cursor', 'pointer');
			$this.find('a').click(function (event) {
				event.preventDefault();
			});

			if ($this.find('a').attr('target') == '_blank') {
				$this.click(function () {
					window.open($('a', this).attr('href'));
				});
			} else {
				$this.click(function () {
					window.location.href = $('a', this).attr('href');

					$('#notes').html(camera);
				});
			}
		});
	}



	/*
     *  Funzioni per PhotoSwiper
     */
	function addImageSizeForPhotoSwiper() {
		var thumbs = $('img[data-big-size]');
		thumbs.each(function (index) {
			if ($(this).parent('a').length > 0) {
				var isImageLink = $(this).parent('a').attr('href').match(/\.(jpeg|jpg|gif|png)$/);
				if (isImageLink) {
					big_size = $(this).data('big-size');
					link = $(this).parent('a');
					link.attr('data-size', big_size);
					link.wrap('<div class="single-image"></div>');
				}
			}
		});
	}

	function initPhotoSwiper(selector) {
		var galleryItems = $(selector);
		var pswpItems = [];

		galleryItems.each(function (index) {
			var dimensions = $(this).find('a').data('size').split('x');
			var width = parseInt(dimensions[0], 10);
			var height = parseInt(dimensions[1], 10);

			myImage = {
				src: $(this).find('a').attr('href'),
				w: width,
				h: height,
				msrc: $(this).find('img').attr('src')
			};

			pswpItems.push(myImage);
		});


		galleryItems.each(function (index) {
			$(this).click(function (evt) {
				evt.preventDefault();
				openPhotoSwipe(pswpItems, index);
			});
		});
	}

	function openPhotoSwipe(galleryItems, index) {
		var options = {
			index: index
		};
		var pswpElement = $('.pswp')[0];

		var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
		gallery.init();
	}



	function $j(argument) {
		var result = jQuery(argument);
		if (result.length === 0) return null;
		else return result;
	}



	function translateCountdown(langCountdown) {

		countdown.resetLabels();

		if (langCountdown == 'it') {
			countdown.setLabels(
				' millisecondo| secondo| minuto| ora| giorno| settimana| mese| anno| decade| secolo| millennio',
				' millisecondi| secondi| minuti| ore| giorni| settimane| mesi| anni| decadi| secoli| millenni',
				' e ',
				' '
			);
		} else if (langCountdown == 'de') {
			countdown.setLabels(
				' Millisekunde| zweite| Minute| jetzt| Tag| Woche| Monat| Jahr| Jahrzehnt| Jahrhundert| Jahrtausend',
				' Millisekunden| Sekunden| Minuten| Stunden| Tage| Wochen| Monate| Alter| Jahrzehnte| Jahrhunderte| Jahrtausende',
				' und ',
				' '
			);
		} else if (langCountdown == 'fr') {
			countdown.setLabels(
				' milliseconde| deuxième| minute| maintenant| jour| semaine| mois| année| décennie| siècle| millénaire',
				' millisecondes| secondes| minutes| heures| journées| semaines| mois| âge| décennies| siècles| millénaires',
				' et ',
				' '
			);
		}

	}

	function edtCountdown() {

		jQuery(".edt_countdown_class").find('.item').each(function () {

			var dataInizio = "";
			var questo = jQuery(this);
			jQuery.post(

				url.ajax_url,
				{
					'action': 'edita_ajax_get_start_countdown_date',
					'offerId': questo.data('offerid'),
				},

				function (response) {

					setInterval(function () {
						stampaCountdown(questo, response);

					}, 3600);
				}
			);
		});
	}

	function stampaCountdown(item, response) {

		jQuery(item).find('.countdown').empty().append(
			moment().countdown(response, countdown.DAYS | countdown.HOURS).toString()
		);
	}


	function checkMenuState() {

		var width = jQuery(window).width();

		if (width > 991) {

			$('#main-menu').show();

		} else {

			$('#main-menu').hide();
		}

	}



	var resizeEnd;

	$j(window).on('resize', function () {

		clearTimeout(resizeEnd);

		resizeEnd = setTimeout(function () {
			$j(window).trigger('resizeEnd');
		}, 500);

	});



	jQuery(window).on('resizeEnd', function () {
		setPageGallerySlider();
	})



	function setPageGallerySlider() {

		var width = jQuery(window).width();

		var slideCount = 4;

		if (width > 767) {

			// 3cols...
			slideCount = 4;


		} else if (width > 479) {

			slideCount = 2;

		} else {

			slideCount = 1;
		}

		jQuery('.page-gallery-slideshow').cycle('destroy');

		jQuery('.page-gallery-slideshow').cycle({
			fx: 'carousel',
			timeout: 0,
			speed: 600,
			carouselVisible: slideCount,
			carouselFluid: true,
			slides: '.slide',
			prev: '#slider-prev',
			next: '#slider-next',
			autoHeight: 'calc'
		});

	}


	$j(document).ready(function () {

		scrollHeader();
		allClick();
		cameraClick();
		setPageGallerySlider();

		initPhotoSwiper(".gallery-image");

		if (typeof lang && lang != 'en') {
			translateCountdown(lang);
		}

		edtCountdown();


		//note(@duncanmid): filter button states

		if (jQuery('.item-filter button').length) {

			$j('.item-filter button').click(function () {

				var id = $j(this).data('id');

				if (typeof (id) != "undefined") {
					$j('.item-filter button').removeClass('selected');
					$j('.offerte-category-description').hide();

					$j(this).addClass('selected');
					$j('#' + id).fadeIn();
				}

			});
		}




		if (jQuery('.embed-youtube').length) {
			$j('.embed-youtube').click(function () {

				var codice = $j(this).data('embed');
				var iframe = document.createElement("iframe");

				$j(this).css({ 'background-image': 'none', 'background-color': 'transparent' });

				iframe.setAttribute("frameborder", "0");
				iframe.setAttribute("allowfullscreen", "");
				iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
				$j(this).html('');
				$j(this).append(iframe);

			});
		}



		//note(@duncanmid): main menu controls

		/* $j('#menu-toggle').click(function() {
			
			$j('#main-menu').fadeIn('slow');
		});
		
		$j('#menu-close').click(function() {
			
			$j('#main-menu').fadeOut('fast');
		}); */



		//note(@duncanmid): parchi
		if (jQuery('.parco > h4').length) {

			$j('.parco > h4').click(function () {

				if ($j(this).hasClass('opened')) {

					$j(this).removeClass('opened');
					$j('.parco > .parco-inner').hide();

				} else {

					$j('.parco > h4').removeClass('opened');
					$j('.parco > .parco-inner').hide();


					$j(this).addClass('opened');
					$j(this).next().fadeIn();
				}
			});

		}



		//note(@duncanmid): offerta cta

		if (jQuery('#offerta-cta').length) {

			$j('#offerta-cta').click(function () {

				var offer = $j(this).data('offer');

				$j('#notes').html(offer);

			});
		}




		//note(@duncanmid): filter offerte by #

		if (jQuery(window).width() < 768) {
			var filterSelect = '.select-offers',
				container = '.mix-filter-support';

			if (jQuery(container).length) {
				var mixer = mixitup(container);

				$(filterSelect).on('change', function () {
					mixer.filter(this.value);
				});
			}
		}
		else {
			var containerEl = document.querySelector('.mix-filter-support');

			if (containerEl != null) {

				var pHash = window.location.hash;
				var defaultClassFilter = "";
				var defaultId = '';

				defaultClassFilter = pHash.replace("#", ".");
				defaultId = pHash.replace("#", '');

				// categoria offerta predefinita da visualizzare in "edt_config.firstFilter" (slug)
				if (defaultClassFilter == "" && typeof (edt_config.firstFilter) != "undefined") {
					defaultClassFilter = '.' + edt_config.firstFilter;
				}

				var defaultInputFilter = jQuery('.item-filter [data-filter="' + defaultClassFilter + '"]');
				var mixArgs = {};

				if (defaultInputFilter.length > 0) {
					mixArgs.load = {};
					mixArgs.load.filter = defaultClassFilter;
				}

				//set selected filter button

				if (pHash.length || defaultClassFilter != "") {

					jQuery('.item-filter button').removeClass('selected');
					jQuery('[data-filter="' + defaultClassFilter + '"]').addClass('selected');

					jQuery('#category-' + defaultId).show();
				}

				var mixer = mixitup(containerEl, mixArgs);
			}
		}

		// end


		//note(@duncanmid): gallery block

		if (jQuery('.gallery-block-link').length) {

			$j('.gallery-block-link').click(function (e) {

				e.preventDefault();
			});
		}


	});



	$j(window).load(function () {






	});

	$j(window).resize(function () {

		checkMenuState();
	});

})(jQuery);
